/**
 * SHADOW WIDGET OBSERVER - CHANGELOG
 * 
 * Natulim TS - 06-feb-26 CA-4 : Refactorización a función reutilizable + Widget Recharge
 * - PROBLEMA: Código duplicado para observar múltiples widgets con Shadow DOM
 * - SOLUCIÓN: Crear función genérica observeShadowWidget() que acepta configuración
 * - BENEFICIOS:
 *   * Una sola función para manejar todos los widgets con Shadow DOM
 *   * Configuración declarativa mediante objeto de parámetros
 *   * Callback personalizado (onFound) para lógica específica por widget
 *   * Fácil escalabilidad para agregar nuevos widgets
 * - FUNCIONES:
 *   * observeShadowWidget(): Observa y modifica cualquier widget con Shadow DOM
 * - WIDGETS CONFIGURADOS:
 *   * Aftersell (#aftersell-pdp-upsell): Estilos grid + traducciones catalán
 *   * Recharge (recharge-subscription-widget): Estilos flexbox para opciones de compra
 * 
 * Natulim TS - 12-feb-26 CA-7 : Sistema de traducciones dinámicas por ID de contenedor
 * - PROBLEMA: Traducciones hardcodeadas, mismo texto para todos los widgets Aftersell
 * - SOLUCIÓN: Sistema de mapeo de traducciones basado en el ID del div contenedor Shopify
 * - IMPLEMENTACIÓN:
 *   * Detección automática del ID del contenedor padre (shopify-block-*)
 *   * Objeto CONTAINER_TRANSLATIONS con mapeo ID -> traducciones
 *   * Fallback a traducciones DEFAULT si no existe el ID específico
 *   * Parámetro containerId añadido al callback onFound
 *   * Extracción del sufijo único del ID (parte después de último __)
 */

function observeShadowWidget(config) {
  const {
    selector,
    targetSelector,
    stylesId,
    styles,
    onFound,
    timeout = 10000
  } = config;
  
  const mainObserver = new MutationObserver(function() {
    const widget = document.querySelector(selector);
    
    if (widget && widget.shadowRoot) {
      const shadowRoot = widget.shadowRoot;
      
      const innerObserver = new MutationObserver(function() {
        const targetElement = shadowRoot.querySelector(targetSelector);
        
        if (targetElement) {
          innerObserver.disconnect();
          
          if (styles && !shadowRoot.querySelector(`#${stylesId}`)) {
            const styleElement = document.createElement('style');
            styleElement.id = stylesId;
            styleElement.textContent = styles;
            shadowRoot.appendChild(styleElement);
          }
          
          if (onFound && typeof onFound === 'function') {
            // Buscar el div padre con el ID de Shopify
            const parentDiv = widget.closest('[id^="shopify-block-"]');
            const containerId = parentDiv ? parentDiv.id : null;
            onFound(shadowRoot, targetElement, widget, containerId);
          }
        }
      });
      
      innerObserver.observe(shadowRoot, {
        childList: true,
        subtree: true
      });
      
      mainObserver.disconnect();
      setTimeout(() => innerObserver.disconnect(), timeout);
    }
  });
  
  mainObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  setTimeout(() => mainObserver.disconnect(), timeout);
}

// Natulim TS - 12-feb-26 CA-7 : Mapeo de traducciones por sufijo único del widget
// Formato: shopify-block-[DINAMICO]__aftersell_by_rokt_pdp_upsells_[SUFIJO_UNICO]
// Solo usamos el SUFIJO_UNICO como clave para evitar problemas con la parte dinámica
const CONTAINER_TRANSLATIONS = {
  'MHpn7b': {
    ca: {
      header: 'Triats junts a moltes cases',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  '7dMEgf': {
    ca: {
      header: 'El duet més desitjat a la rentadora',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'VWbnap': {
    ca: {
      header: 'Moltes famílies els fan servir junts',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'Xezm9m': {
    ca: {
      header: 'Quan la bugada s\'acaba, la casa continua...',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'zqz6AX': {
    ca: {
      header: 'Per a una vaixella sense tòxics, els nostres clients ho combinen amb...',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  '6RXh6G': {
    ca: {
      header: 'Per a allò que el greix no perdona',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'i99yhJ': {
    ca: {
      header: 'Dos bàsics que es reposen sovint',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'NdFTaX': {
    ca: {
      header: 'Molt habitual junt amb els esprais',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'EY4QeN': {
    ca: {
      header: 'Del greix a la llar. Un combo intel·ligent.',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'amJAKb': {
    ca: {
      header: 'Per al que el greix no perdona',
      button: 'AFEGIR AL CARRETÓ'
    }
  },

  'QxtPXy': {
    ca: {
      header: 'Per mantenir la rutina tot el dia',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'pJAQrt': {
    ca: {
      header: 'Triats junts en moltes llars',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'gchXDB': {
    ca: {
      header: 'Moltes famílies ho fan servir junt',
      button: 'AFEGIR AL CARRETÓ'
    }
  },
  'DEFAULT': {
    ca: {
      header: 'Els nostres clients els compren junts',
      button: 'AFEGIR AL CARRETÓ'
    }
  }
};

// Natulim TS - 12-feb-26 CA-7 : Función para extraer el sufijo único del ID del contenedor
function extractWidgetSuffix(containerId) {
  if (!containerId) return null;
  
  // Patrón: shopify-block-[DINAMICO]__aftersell_by_rokt_pdp_upsells_[SUFIJO]
  // Extraemos todo después del último underscore
  const parts = containerId.split('_');
  return parts[parts.length - 1]; // Retorna el sufijo único (ej: "i99yhJ")
}

document.addEventListener('DOMContentLoaded', function() {
  observeShadowWidget({
    selector: '#aftersell-pdp-upsell',
    targetSelector: '.pdp-widget',
    stylesId: 'custom-styles',
    styles: `
      .pdp-widget .vertical-layout-divider {
        display: grid !important;
        grid-template-columns: 1fr .75fr !important; 
        gap: 14px !important;
        font-family: Bricolage Grotesque !important;
      }
      
      .pdp-widget .product-title,
      .pdp-widget .select-dropdown {
        font-weight: 500 !important;
      }
      
      .pdp-widget .select-dropdown {
        padding: 0px 16px !important;
        text-align: start !important;
        height: 40px !important;
      }
      .upsell-header {
        font-family: Bricolage Grotesque !important;
      }
      
      @media (max-width: 768px) {
        .pdp-widget .vertical-layout-divider {
          grid-template-columns: 1fr !important;
        }
        .pdp-widget .product-card {
          padding: 8px !important;
        }
        .pdp-widget .product-image {
          width: 120px !important;
          height: 120px !important;
        }
        .pdp-widget .product-image-wrapper {
          align-items: start;
        }
        .pdp-widget .product-info {
          padding-bottom: 0px !important;
        }
        .pdp-widget .select-dropdown {
          height: 35px !important;
        }
        .pdp-widget .add-button {
          height: 40px !important;
        }
        .pdp-widget .carousel-button {display:none!important}
        .pdp-widget .product-card-container.horizontal{flex-direction:column;width:100%;max-width:100%;align-items:center;}
        .pdp-widget .carousel-wrapper{justify-content:start;}
        .pdp-widget .product-card.horizontal{flex-direction:row;max-width:90%}
      }
    `,
    onFound: function(shadowRoot, targetElement, widget, containerId) {
      if (typeof Shopify !== 'undefined' && Shopify.locale === 'ca') {
        // Natulim TS - 12-feb-26 CA-7 : Extraer sufijo único y obtener traducciones
        const widgetSuffix = extractWidgetSuffix(containerId);
        const translations = CONTAINER_TRANSLATIONS[widgetSuffix] || CONTAINER_TRANSLATIONS['DEFAULT'];
        
        // Aplicar traducciones
        const upsellHeader = shadowRoot.querySelector('.pdp-widget .upsell-header');
        if (upsellHeader && translations.ca.header) {
          upsellHeader.textContent = translations.ca.header;
        }
        
        const addButton = shadowRoot.querySelector('.pdp-widget .add-button');
        if (addButton && translations.ca.button) {
          addButton.textContent = translations.ca.button;
        }
      }
    }
  });
  
  observeShadowWidget({
    selector: 'recharge-subscription-widget',
    targetSelector: '.rc-purchase-option.rc-selection__onetime',
    stylesId: 'custom-onetime-styles',
    styles: `
      .rc-purchase-option.rc-selection__onetime 
      .rc-purchase-option__label {
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        justify-content: flex-start !important;
        gap: 8px !important;
      }
      .rc-purchase-option.rc-selection__onetime 
      .rc-purchase-option__prices {
        margin-left: 0 !important;
      }
    `
  });
});